import axios from 'axios';

// WWW는 로그인 없는 공개 사이트라 MAG의 axios.js에 있던 토큰 첨부·세션 만료 처리·
// 전역 로딩 오버레이 로직은 필요 없다. baseURL + 타임아웃만 있는 최소 구성.
// REACT_APP_API_URL은 englishpop_front/WWW/.env(.development/.production)에서 설정한다.
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
});

export default instance;
